var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ext-app-wrapper"},[(_vm.loading)?_c('zjy-loading'):_vm._e(),(_vm.urlWithTicket)?_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"frame",attrs:{"id":_vm.code,"src":_vm.urlWithTicket},on:{"load":_vm.onIframeLoad}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }